module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.dfcb7a58.svg";